// FERTILISER
export const ROUTE_CREATE_ORDER = '/create-order';
export const ROUTE_CUSTOMER_ORDERS = '/customer-orders';
export const ROUTE_ORDERS_FAILED = '/customer-orders/failed';

// CROP PROTECTION
export const ROUTE_CROP_HOME = '/crop-protection';
export const ROUTE_CREATE_CROP_ORDER = 'create-order';
export const ROUTE_CROP_CUSTOMER_ORDERS = 'customer-orders';
export const ROUTE_CROP_ORDERS_FAILED = 'customer-orders/failed';

// SEED
export const ROUTE_SEED_HOME = '/seed';
export const ROUTE_CREATE_SEED_ORDER = 'create-order';
export const ROUTE_SEED_CUSTOMER_ORDERS = 'customer-orders';
export const ROUTE_SEED_ORDERS_FAILED = 'customer-orders/failed';

// ENVIRONMENTAL CROPS
export const ROUTE_ENVIRONMENTAL_CROPS_HOME = '/environmental-crops';
export const ROUTE_CREATE_ENVIRONMENTAL_CROPS_ORDER = 'create-order';
export const ROUTE_ENVIRONMENTAL_CROPS_CUSTOMER_ORDERS = 'customer-orders';
export const ROUTE_ENVIRONMENTAL_CROPS_ORDERS_FAILED = 'customer-orders/failed';
